import urlBuilder from "@Utils/urlBuilder";
import config from "config";

const Meta = {
  build(meta: any) {
    meta = meta || {};

    // Title builder -  50-60 chars
    if (meta.title_prefix?.length > 0) {
      if (config.IS_WHITELABEL_APP) {
        meta.title = meta.title_prefix.replace(/\s*\|\s*Amber\s*$/i, "").trim();
      } else {
        meta.title = meta.title_prefix;
        if (meta.title_prefix?.length < 55 && !meta.title_prefix?.toLowerCase().includes("amber")) {
          meta.title = `${meta.title_prefix} | Amber`;
        }
      }
    }

    // for whitelabel, only process title and return early
    if (config.IS_WHITELABEL_APP) {
      return meta;
    }

    // meta description must not exceed 160 characters
    if (meta.url) {
      meta.url = new URL(meta.url, config.WEB_SERVICE_URL).href;
    } else {
      meta.url = config.WEB_SERVICE_URL;
    }

    // Description
    meta.default_description = `${meta.title ? meta.title : ""} - ${
      meta.showZhDescription
        ? "查找并预订大学附近安全实惠的校外学生公寓。浏览超过 10000 家住宿、私人宿舍、公寓和房产。"
        : "Find and book safe and budget-friendly off-campus student housing near university. Browse from 10000+ accommodations, private halls, apartments, properties."
    }`;
    if (!meta.hideDefaultDescription) {
      meta.description = meta.description || meta.meta || meta.default_description;
    }

    // Keyword builder
    meta.keywords = meta.keywords || [];
    if (meta.showZhDescription) {
      meta.keywords = meta.keywords.concat([
        "Amber",
        "amber student",
        "学生住宿",
        "学生宿舍",
        "学生公寓",
        "校外住宿",
      ]);
    } else {
      meta.keywords = meta.keywords.concat([
        "Amber",
        "amber student",
        "student accommodation",
        "student housing",
        "student apartments",
        "off campus housing",
      ]);
    }

    meta.keywords = Array.from(new Set(meta.keywords)).join(", ");

    // prev url suffix
    if (meta.prev_url_suffix?.length > 0) {
      const paths = [];
      paths.push(config.WEB_SERVICE_URL);
      paths.push(meta.prev_url_suffix);
      meta.prevUrl = urlBuilder(paths);
    }

    // next url Suffix
    if (meta.next_url_suffix?.length > 0) {
      meta.nextUrl = new URL(meta.next_url_suffix, config.WEB_SERVICE_URL).href;
    }

    // Canonical URL Suffix
    if (meta.canonical_url_suffix?.length > 0) {
      meta.canonicalUrl = new URL(meta.canonical_url_suffix, config.WEB_SERVICE_URL).href;
    }

    // Seo
    meta.sitemapLink = "/sitemap";
    meta.index = !(meta.index == false || !config.isProduction || config.IS_WHITELABEL_APP);
    meta.schemaData = meta.schemaData || [];

    // Facebook
    meta.ogImage =
      meta.ogImage || `${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/768 - tab.png?q=90`;
    meta.ogSiteName = meta.ogSiteName || "Amberstudent";
    meta.ogTitle = meta.ogTitle || meta.title;
    meta.ogUrl = meta.ogUrl || meta.canonicalUrl || meta.url;
    meta.ogDescription = meta.ogDescription || meta.description;
    meta.ogType = "product";
    meta.fbAppId = "1158664500856575";

    // Twitter
    meta.twitterUrl = meta.twitterUrl || meta.ogUrl || meta.canonicalUrl || meta.url;
    meta.twitterTitle = meta.twitterTitle || meta.ogTitle || meta.title;
    meta.twitterDescription = meta.twitterDescription || meta.ogDescription || meta.description;
    meta.twitterImageSrc = meta.twitterImageSrc || meta.ogImage;
    meta.twitterCard = "summary_large_image";
    meta.twitterSite = "@amberstudentcom";
    return meta;
  },
};

export default Meta;
